import { render, staticRenderFns } from "./CopyInfo.vue?vue&type=template&id=661f8288&scoped=true&"
import script from "./CopyInfo.vue?vue&type=script&lang=js&"
export * from "./CopyInfo.vue?vue&type=script&lang=js&"
import style0 from "./CopyInfo.vue?vue&type=style&index=0&id=661f8288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661f8288",
  null
  
)

export default component.exports